
<template>
    <div class="wrap">
        <div class="header">
            <div class="header-left" @click="goBack"><img src="@/assets/public/icon_back.png" alt=""/></div>
            <div class="header-main">升级提示</div>
            <div class="header-right">
                <img src="@/assets/public/icon_customerservice.png" alt="" @click="pushCusService"/>
            </div>
        </div>
        <div class="content">
            <img src="@/assets/vipGoods/icon_sjts.png" alt="">
            <p>请升级到最新版本体验该功能！</p>
            <div class="btn" @click="goBack">我知道了</div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        // 在线客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        }
    },
    created () {
        this.$jsBridge.callBackHandler('isShowNavigationBar', { isHidden: true })
    }
}
</script>
<style scoped lang="scss">
.header{
    position: sticky;
    top: 0;
    z-index: 9;
    background: #ffffff;
    display: flex;
    align-items: center;
    padding: 13px 10px;
    .header-left,.header-right{
        display: flex;
        align-items: center;
        width: 100px;
        img{
            width: 24px;
        }
    }
    .header-right{
        justify-content: end;
        img+img{
            margin: 0 0 0 13px;
        }
    }
    .header-main{
        white-space: nowrap;
        text-align: center;
        flex: 1;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
    }
}
.content{
    overflow: hidden;
    img{
        display: block;
        margin: 137px auto 0;
        width: 200px;
    }
    p{
        text-align: center;
        margin: 15px 0 0 0;
        font-size: 15px;
        color: #333333;
    }
    .btn{
        margin: 20px auto;
        width: 180px;
        height: 45px;
        background: #53CB85;
        border-radius: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 600;
        color: #FFFFFF;
    }
}

</style>
